module.exports = __webpack_public_path__ + "assets/bd64c268a9978da654eafcdb7db2f662.ttf";